import { actorDataExportSchema, type ActorDataExport } from "#actor-data-export-schema";

export function parseActorDataExportJson(json: string): ActorDataExport {
  let parsed: unknown;
  try {
    parsed = JSON.parse(json);
  } catch {
    throw new TypeError("This file is not valid JSON.");
  }

  const result = actorDataExportSchema.safeParse(parsed);
  if (!result.success) {
    throw new TypeError(
      "This file is not a valid Han data export or uses an unsupported export version.",
    );
  }
  return result.data;
}

export function serializeActorDataExport(data: ActorDataExport): string {
  return `${JSON.stringify(actorDataExportSchema.parse(data), null, 2)}\n`;
}
